module.exports = __webpack_public_path__ + "img/yxmh_03.7fc23036.jpg";